// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"c5bcc3eb","154":"f500f187","453":"f0800a77","513":"80918693","912":"ebe26cd4","958":"a5bb2883"}[chunkId] + ".chunk.js";
};